<section class="ula-modal" role="dialog" aria-modal="true" [attr.aria-label]="data.heading">
  <header class="ula-header">
    <h3>{{ data.heading }}</h3>
  </header>

  <div class="ula-body-shell">
    <div class="ula-body" #contentScroll (scroll)="onScroll()">
      <div class="ula-content" [innerHTML]="renderedDisclaimerHtml"></div>
    </div>
  </div>

  <footer class="ula-footer">
    <div class="footer-scroll-cue" [class.is-visible]="showScrollCue" [attr.aria-hidden]="showScrollCue ? null : 'true'">
      <div class="footer-scroll-arrow"></div>
      <div class="footer-scroll-arrow"></div>
    </div>

    @if (saveErrorMessage) {
      <p class="ula-error">{{ saveErrorMessage }}</p>
    }

    <button
      type="button"
      class="agree-btn"
      data-testid="ula-agree-btn"
      [disabled]="!canAgree"
      (click)="agreeAndContinue()"
    >
      {{ data.buttonText }}
    </button>
  </footer>
</section>
